import { MouseEventHandler } from 'react';
import { Box } from '@chakra-ui/react';
import { Button } from 'components/elements/Button';
import { Text } from 'components/elements/Text';
import { PencilIcon } from 'components/icons/PencilIcon';

type PencilIconButtonProps = {
  label?: string;
  handleClick: MouseEventHandler<HTMLButtonElement> | undefined;
  sx?: any;
};

export const PencilIconButton = ({ handleClick, label, sx }: PencilIconButtonProps) => (
  <Button
    color="secondary"
    className="edit-button"
    onClick={handleClick}
    sx={{ background: 'none', ...sx }}
  >
    <Box
      sx={{
        cursor: 'pointer',
        display: 'flex',
        gap: '13px',
        alignItems: 'center',
        background: 'none',
        color: 'green',
        fontSize: '12px',
        lineHeight: '14px',
        letterSpacing: '-0.02em',
      }}
    >
      <PencilIcon />
      <Text>{label || 'Edit'}</Text>
    </Box>
  </Button>
);
